export default __webpack_public_path__ + "static/media/rock-pools.697ef6b8.png";